<template>
<b-col cols="12">
  <div class="innerContent w100 contStats">
    <b-button-group id="mode" class="menuOpt tabs">
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hasPH" @click="changeVal('ph')" :pressed="type === 'ph'">PH</b-button>
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hasRX" @click="changeVal('rx')" :pressed="type === 'rx'">RX</b-button>
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hasCD" @click="changeVal('cd')" :pressed="type === 'cd'">CD</b-button>
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hasCL" @click="changeVal('cl')" :pressed="type === 'cl'">CL</b-button>
        <!-- TEMPERATURE / FILTRATION -->
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hideTemperature === 0" @click="changeVal('temp')" :pressed="type === 'temp'">{{ $t("messages.temperature") }}</b-button>
        <b-button class="optInt" style="margin:0px;" v-if="poolData.main.hideFiltration === 0" @click="changeVal('filtration')" :pressed="type === 'filtration'">{{ $t("messages.filtration") }}</b-button>
    </b-button-group>

  </div>
  <beat-loader :loading="isLoading" :color="color" class="loading"></beat-loader>
  <div ref="chartdiv" class="cont" style="height:450px">  </div>
      <modal name="login-box"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="250"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="30%"
        height="auto"
        :clickToClose="false">
        <div class="modal-detail-content">
            <b-row>
                <b-btn @click="$modal.hide('login-box');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            </b-row>
            <b-col>
                <login-box v-on:onLogin="onLogin"></login-box>
            </b-col>
        </div>
    </modal>
</b-col>


</template>

<script>
import { mapState} from 'vuex'
import LoginBox from './utils/LoginBox.vue'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
const {fb,auth} = require('../firebaseConfig.js')

am4core.useTheme(am4themes_animated);
am4core.addLicense("CH435087100");

// am4core.useTheme(am4themes_dark);

export default {
  name: 'Stats',
  components: {
    BeatLoader,
    LoginBox
  },
  props: {
        poolData: null
    },
    data() {
        return {
          chart: {},
          type: 'ph',
          isLoading : false,
          stats:[],
          cached:{},
          color: '#00b3db'
        }
    },
    computed: {
        ...mapState(['userToken', 'currentUser'])
    },
    mounted() {
      if(this.poolData.isDemo){
        this.getDemoFromApi()
      }else{
        this.getDataFromApi()
      }
    },
    methods: {
      onLogin(login){
        var credential = fb.auth.EmailAuthProvider.credential(
            this.currentUser.email,
            login.password
        );
        this.currentUser.reauthenticateAndRetrieveDataWithCredential(credential).then( () => {
          // Re-authenticated user
            this.$modal.hide('login-box');
            this.getDataFromApi()
        }).catch(function(error) {
            console.log(error);
        });
      },
      getDataFromApi () {
        this.isLoading = true
        if(!this.cached[this.type]){
        this.$store.dispatch('getPoolStats', { pool: this.poolData, period: 14, type: this.type}).then(response => {
            let reg = response.data[0]
            this.cached[this.type] = reg;
            this.fillData(reg);
          }, error => {
            this.$modal.show('login-box');
          })
        } else {
          // data from cache
          this.fillData(this.cached[this.type]);
        }
      },
      getDemoFromApi () {
        this.isLoading = true
        if(!this.cached[this.type]){
        this.$store.dispatch('getDemoStats', { pool: this.poolData, period: 14, type: this.type}).then(response => {
            let reg = response.data[0]
            this.cached[this.type] = reg;
            this.fillData(reg);
          }, error => {
            this.$modal.show('login-box');
          })
        } else {
          // data from cache
          this.fillData(this.cached[this.type]);
        }
      },
      changeVal(val) {
        this.type = val;
        if(this.poolData.isDemo){
          this.getDemoFromApi()
        }else{
          this.getDataFromApi()
        }
      },

      fillData(values){
        // let chart = this.chart
        let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
        let data = [];
        for (let i = 1; i < values.length; i++) {
          let t = new Date(Date.UTC(1970, 0, 1)); 
          t.setUTCSeconds(values[i].seconds);
        
          let val = (this.type == 'ph') ? parseFloat(values[i].field / 100).toFixed(1) : values[i].field;
          data.push({ date: t, type: this.type, value: val});
        }

        chart.data = data;
        // Create axes
        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        // dateAxis.baseInterval = {
        //   "timeUnit": "minute",
        //   "count": 30
        // };

    //    dateAxis.skipEmptyPeriods = true;
        dateAxis.tooltipDateFormat = "dd-MM-yyyy HH:mm";
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        if(this.type == 'filtration'){
          valueAxis.min = 0;
          valueAxis.max = 1;
          valueAxis.adjustLabelPrecision = false;
          chart.numberFormatter.numberFormat = "";

          var range = valueAxis.axisRanges.create();
              range.value = 0;
              range.label.text = "OFF";

          var range = valueAxis.axisRanges.create();
              range.value = 1;
              range.label.text = "ON";
        }

        // Create series
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.minBulletDistance = 15;
       // series.tooltip = "{value}");
        series.adapter.add('tooltipText', (text, target) => {
          let data = target.tooltipDataItem.dataContext;
            if (target.tooltipDataItem.dataContext) {
              let val = data.value;
              if(this.type == 'filtration'){
                val = (val == 0) ? 'OFF' : 'ON'
              }
              return val;
            }
            else {
              return text;
            }
        });
                
        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 10;
        series.tooltip.label.minHeight = 10;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";

        // Make bullets grow on hover
        let bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 4;
        bullet.circle.fill = am4core.color("#fff");

        let bullethover = bullet.states.create("hover");
        bullethover.properties.scale = 1.3;

        // Make a panning cursor
        chart.cursor = new am4charts.XYCursor();
        //chart.cursor.behavior = "panXY";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.snapToSeries = series;

        // Create vertical scrollbar and place it before the value axis
        chart.scrollbarY = new am4core.Scrollbar();
        chart.scrollbarY.parent = chart.leftAxesContainer;
        chart.scrollbarY.toBack();

        // Create a horizontal scrollbar with previe and place it underneath the date axis
        chart.scrollbarX = new am4charts.XYChartScrollbar();
        chart.scrollbarX.series.push(series);
        chart.scrollbarX.parent = chart.bottomAxesContainer;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "pool-"+this.poolData.id;
        chart.exporting.dateFields.push("date");
        chart.exporting.dateFormat = "yyyy-MM-dd HH:mm";     

        // chart.events.on("ready", function () {
        //   dateAxis.zoom({start:0.79, end:1});
        // });
        this.isLoading = false
       // this.chart = chart
      },
    }
     
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cont {
  width: 100%;
  height: 100%;
}

.amcharts-amexport-item {
  border: 2px solid #777;
}

.amcharts-amexport-top .amcharts-amexport-item > .amcharts-amexport-menu {
  top: -3px!important;
  left: 20px
}
</style>


// WEBPACK FOOTER //
// src/components/Stats.vue